import styles from './Beacon.module.css';

export function Beacon({
  className,
  state,
}: {
  className?: string;
  state: 'active' | 'inactive' | 'pending' | 'error';
}) {
  return (
    <div
      data-name="BEACON"
      className={`h-3 w-3 rounded-full ${STATE_CLASSES[state]} ${className}`}
    />
  );
}

const STATE_CLASSES = {
  active: `bg-green-500 ${styles.radiateGreen}`,
  inactive: 'bg-gray-500',
  pending: 'bg-yellow-500',
  error: 'bg-red-500',
};
